export default __webpack_public_path__ + "static/media/icon-card-custom-fields-main.44e42d2c.svg";